<div class="w-full py-3 px-4">
    <!-- 🔹 Report Title -->
<div class="flex items-center justify-between mb-4">
    <h2 class="font-bold text-lg sm:text-xl lg:text-2xl text-c19725 tracking-wide">
      ITEM SOLD INVOICE
    </h2>
  </div>
  

    <!-- 🔹 Filters Row -->
    <div class="flex flex-wrap lg:flex-nowrap justify-between items-center gap-1 sm:gap-2">
      <div class="flex items-center justify-center md:justify-start gap-1 sm:gap-2">
  
        <!-- Rows Filter -->
        <div class="relative flex items-center gap-1 sm:gap-2">
          <label for="rowFilter" class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap">Rows :</label>
          <select id="rowFilter" [(ngModel)]="itemsPerPage" (change)="filterTable()"
            class="border border-dcdcdc rounded-[5px] p-1 text-xs sm:text-sm appearance-none bg-none pr-6 focus:outline-none focus:ring-0 focus:border-c19725">
            <option *ngFor="let count of [5,10,20,30,40,50,100]" [value]="count">{{count}}</option>
          </select>
        </div>
  
        <!-- Global Search -->
        <div class="flex items-center gap-1 sm:gap-2">
          <label for="globalSearch" class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap">Search :</label>
          <input id="globalSearch" type="text" [(ngModel)]="globalSearchText" (ngModelChange)="filterTable()"
            placeholder="Search all columns..."
            class="border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm w-32 lg:w-64 focus:outline-none focus:ring-0 focus:border-c19725"
            autocomplete="off" />
        </div>
      </div>
  
      <!-- 🔹 Export Buttons + Column Visibility -->
      <div class="flex items-center flex-wrap lg:flex-nowrap justify-center md:justify-end gap-2">
  
        <button class="text-[#F20707] border border-[#F20707] bg-[#fff6f3] px-2 py-1 rounded-[5px] text-xs sm:text-sm"
          (click)="downloadPDF()">Download PDF</button>
  
        <button class="text-[#029921] border border-[#029921] bg-[#e6ffe6] px-2 py-1 rounded-[5px] text-xs sm:text-sm"
          (click)="downloadExcel()">Download Excel</button>
  
        <button class="text-[#0720EC] border border-[#0720EC] bg-[#E8E6FF] px-2 py-1 rounded-[5px] text-xs sm:text-sm"
          (click)="downloadJSONAll()">Download JSON</button>
  
        <button class="text-[#00ad94] border border-[#00ad94] bg-[#e5fffb] px-2 py-1 rounded-[5px] text-xs sm:text-sm"
          (click)="downloadCSV()">Download CSV</button>
  
        <!-- Column Visibility Dropdown -->
        <div class="relative inline-block text-left">
          <button (click)="toggleDropdown()"
            class="text-[#B92185] border border-[#B92185] bg-[#FFE1F5] px-2 py-1 rounded-[5px] text-xs sm:text-sm">
            Column Visibility
          </button>
  
          <div *ngIf="showDropdown"
            class="absolute z-50 mt-2 p-4 bg-white border rounded shadow -left-24 w-64">
            <p class="font-semibold mb-2">Select Columns to Show:</p>
  
            <label *ngFor="let field of selectedFields" class="block text-sm mb-1">
              <input type="checkbox" [(ngModel)]="field.selected"
                (change)="saveSelectedColumns()" autocomplete="off" /> {{field.label}}
            </label>
  
            <div class="mt-3 flex flex-col gap-2">
              <button (click)="selectAllFields()" class="text-sm text-blue-600 hover:underline text-left">
                Select All
              </button>
              <button (click)="deselectAllFields()" class="text-sm text-red-800 hover:underline text-left">
                Deselect All
              </button>
  
              <button (click)="applyColumnSelection()"
                class="mt-2 bg-blue-600 text-white text-xs px-3 py-1 rounded-[5px] transition">
                Apply
              </button>
            </div>
          </div>
        </div>
  
        <button (click)="printTable()"
          class="text-[#5606b6] border border-[#5606b6] bg-[#ecddff] px-3 py-1 rounded-[5px] text-xs sm:text-sm">
          Print
        </button>
      </div>
    </div>
  
    <!-- 🧾 Table -->
     <div id="invoice-print-section">
    <div class="overflow-x-auto whitespace-nowrap mt-5 hide-scrollbar">
      <table class="w-full border border-b-0 bg-white border-collapse">
        <thead class="bg-[#F2F2F2] text-xs sm:text-sm text-444">
          <tr>
            <th class="p-2 text-center border-r">No.</th>
  
            <th *ngFor="let field of selectedFields" [hidden]="!field.selected"
              class="p-2 border-r text-left">
              <div class="flex flex-col gap-1 w-32">
  
                <!-- Per-column search -->
                <input type="text" [(ngModel)]="searchValues[field.key]" (ngModelChange)="filterTable()"
                  placeholder="Search {{field.label}}"
                  class="border border-dcdcdc px-2 py-1 text-[10px] rounded-[5px] w-full"
                  autocomplete="off" />
  
                <!-- Sort trigger -->
                <div class="text-xs font-medium text-gray-700 flex items-center gap-1 cursor-pointer"
                  (click)="sortBy(field.key)">
                  {{field.label}}
                  <svg *ngIf="sortKey === field.key" class="w-3 h-3" viewBox="0 0 24 24">
                    <path *ngIf="sortDirection==='asc'" d="M12 8l6 6H6z" fill="currentColor" />
                    <path *ngIf="sortDirection==='desc'" d="M12 16l-6-6h12z" fill="currentColor" />
                  </svg>
                </div>
              </div>
            </th>
            <th class="p-2 text-center border-r">Actions</th>
          </tr>
        </thead>
  
        <tbody class="text-xs sm:text-sm">
  
          <tr *ngIf="paginatedInvoiceList.length === 0">
            <td [attr.colspan]="selectedFields.length + 2"
              class="p-2 border-b text-center">No invoices found.</td>
          </tr>
  
          <tr *ngFor="let item of paginatedInvoiceList; let i = index">
            <td class="p-2 text-center border-r border-b">
              {{(currentPage - 1)*itemsPerPage + i + 1}}
            </td>
  
            <ng-container *ngFor="let field of selectedFields">
              <td *ngIf="field.selected"
                class="p-2 border-r border-b"
                [ngClass]="{
                  'text-blue-600 underline cursor-pointer hover:text-blue-800':
                   field.key === 'invoice_number' || field.key === 'invoice_date'
                }"
                (click)="(field.key === 'invoice_number' || field.key === 'invoice_date') ? previewInvoice(item.id) : null">
  
                {{ item[field.key] || '-' }}
              </td>
            </ng-container>

            <td class="p-2 border-r border-b text-center">
              <button type="button"
                (click)="deleteInvoice(item.id, item.invoice_number)"
                class="h-7 w-7 rounded-md bg-red-50 text-red-400 hover:bg-red-600 hover:text-white transition-all inline-flex items-center justify-center"
                title="Delete invoice">
                <i class="fas fa-trash-alt text-[10px]"></i>
              </button>
            </td>
          </tr>
  
        </tbody>
      </table>
    </div>
    </div>
  
    <!-- 📌 Pagination -->
    <div class="flex justify-end py-3">
      <nav class="inline-flex gap-2">
        <button (click)="goToPreviousPage()" [disabled]="currentPage===1"
          class="w-6 h-6 border rounded text-c19725 hover:bg-[#f6f1cb]">
          ‹
        </button>
  
        <button *ngFor="let page of pageNumbers"
          (click)="goToPage(page)"
          [class.bg-c19725]="currentPage===page"
          [class.text-white]="currentPage===page"
          class="w-6 h-6 border rounded text-xs hover:bg-[#f6f1cb]">
          {{page}}
        </button>
  
        <button (click)="goToNextPage()" [disabled]="currentPage===totalPages"
          class="w-6 h-6 border rounded text-c19725 hover:bg-[#f6f1cb]">
          ›
        </button>
      </nav>
    </div>
  
  </div>
  
  <!-- 🔹 Preview Image Modal -->
  <div *ngIf="previewImage"
    class="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50">
    <div class="bg-white p-4 rounded shadow-xl">
      <img [src]="previewImage" class="max-h-[80vh]">
  
      <button class="mt-3 px-4 py-1 bg-red-600 text-white rounded"
        (click)="closePreview()">Close</button>
    </div>
  </div>
  